<template>
  <v-container class="mt-16 pt-4">
    <v-row>
      <v-col
        sm="12"
        md="12"
        order-md="3"
        lg="4"
        order-lg="1"
        order="2"
      >
        <v-img
          v-if="lgAndUp && activeProductPicture"
          max-width="22.5vh"
          max-height="22.5vh"
          class="mx-auto offset-img rounded-xl elevation-4"
          cover
          :src="activeProductPicture"
        >
          <template v-slot:placeholder>
            <div class="d-flex align-center justify-center fill-height">
              <v-progress-circular
                color="accent"
                indeterminate
                width="2"
                size="50"
              />
            </div>
          </template>
        </v-img>

        <v-card
          color="nicewhite"
          class="px-8 pt-xs-10 card-inner neu-card"
          :class="{'mt-n14 pt-14': lgAndUp}"
        >
          <v-card-text>
            <div>
              <v-skeleton-loader v-if="!productData.name" type="heading" color="transparent" />
              <template v-else>
                <h1 class="monkey-title d-flex">{{ productData.name }}</h1>

                <h2 class="monkey-title text-medium-emphasis">{{ Number(productData.value).toLocaleString(undefined, {minimumFractionDigits: 2}) }}€</h2>
              </template>
            </div>

            <div class="my-5">
              <v-skeleton-loader v-if="!productData.shortDesc" type="paragraph" color="nicewhite" />
              <p v-else class="" v-html="productData.shortDesc" />
            </div>

            <v-btn
              color="accent"
              block
              :loading="!productData.value"
              prepend-icon="fa fa-cart-plus"
              class="neu-button"
              @click="addToCart()"
            >
              Ajouter au panier
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols=""
        sm=""
        order="1"
        md=""
        order-md="2"
      >
        <v-row>
          <v-col
            cols=""
            sm=""
            md=""
            lg=""
            xl="6"
          >
            <v-img
              v-if="activeProductPicture"
              :src="activeProductPicture"
              class="neu-card rounded-xl"
              width="100%"
              cover
            >
              <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                  <v-progress-circular
                    color="nicewhite"
                    indeterminate
                    width="2"
                    size="50"
                  />
                </div>
              </template>
            </v-img>
          </v-col>

          <v-col v-if="smAndUp" cols="auto" class="mr-auto">
            <v-card
              v-for="pictureLink in productData.pictures"
              :key="pictureLink"
              class="mb-3 neu-card"
              color="nicewhite"
              height="10vh"
              width="10vh"
              link
              @click="activeProductPicture = pictureLink"
            >
              <v-img
                :src="pictureLink"
              />
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="!smAndUp">
          <v-col
            v-for="pictureLink in productData.pictures"
            :key="pictureLink"
            cols="auto"
            class="py-0 mx-auto"
          >
            <v-card
              class="mb-2"
              color="nicewhite"
              width="7.5vh"
              link
              @click="activeProductPicture = pictureLink"
            >
              <v-img :src="pictureLink" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-card class="neu-card my-10 mb-13">
      <v-tabs
        v-model="activeTab"
        align-tabs="center"
        fixed-tabs
        stacked
        center-active
        density="comfortable"
      >
        <v-tab value="description" class="text-none">
          <v-icon icon="fa fa-bottle-droplet" size="x-small" class="mb-2" />
          Description
        </v-tab>
        <v-tab value="readme" class="text-none">
          <v-icon icon="fa-brands fa-readme" size="x-small" class="mb-2" />
          Utilisation
        </v-tab>
        <v-tab value="delivery" class="text-none">
          <v-icon icon="fa fa-truck-ramp-box" size="x-small" class="mb-2" />
          Livraison
        </v-tab>
      </v-tabs>

      <v-card-text>
        <v-tabs-window v-model="activeTab">
          <v-tabs-window-item value="description">
            <span v-html="productData.longDesc" />
          </v-tabs-window-item>

          <v-tabs-window-item value="readme">
            Matin et soir, prélevez une noisette de crème et appliquez-la délicatement sur le visage et le cou parfaitement nettoyés. Massez délicatement jusqu'à complète absorption.
          </v-tabs-window-item>

          <v-tabs-window-item value="delivery">
            <p class="text-body-1">Toutes les commandes sont expédiées sous 24H depuis notre entrepôt en France.</p>

            <small><span class="text-body-1 font-weight-bold">Offerte à partir de 60€ d'achat</span> (en France Métropolitaine via Mondial relay)</small>

            <v-list
              :items="deliveryItems"
              bgColor="transparent"
              lines="two"
            />
          </v-tabs-window-item>
        </v-tabs-window>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="loadingProduct"
      max-width="600"
      :scrim="loadingDialog.color"
      persistent
    >
      <v-list
        class="py-2"
        color="accent"
        elevation="12"
        rounded="lg"
      >
        <v-list-item>
          <template v-slot:title>
            <span :class="`text-${loadingDialog.color}`">{{ loadingDialog.text }}</span>
          </template>
          <template v-if="loadingDialog.color == 'error'" v-slot:subtitle>
            <NuxtLink :class="`text-${loadingDialog.color}`" to="/">Retourner à l'accueil</NuxtLink>
          </template>

          <template v-slot:prepend>
            <div class="pe-4">
              <v-img
                src="@/assets/logos/meili_logo_m_black.png"
                width="2.5rem"
              />
            </div>
          </template>

          <template v-slot:append>
            <v-progress-circular
              :color="loadingDialog.color"
              :indeterminate="loadingDialog.spinnerValue == 0"
              :model-value="loadingDialog.spinnerValue"
              size="16"
              width="2"
            />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { useDisplay } from "vuetify";

const { smAndUp, lgAndUp } = useDisplay();

definePageMeta({
  title: "Notre crème",
});
</script>

<script>
import axios from "axios";
import { useStoreStore } from "~/stores/store";
import { useCartStore } from "~/stores/cart";

export default {
  name: "ProductPage",
  data() {
    return {
      activeProductPicture: "",

      productData: {
        pictures: [],
      },

      activeTab: "description",
      deliveryItems: [
        {
          title: "Livraison en point relais 4,99€",
          props: {
            subtitle: "Mondial Relay",
            class: "px-0",
          },
        },
        {
          title: "Livraison à domicile 8,99€",
          props: {
            subtitle: "Colissimo",
            class: "px-0",
          },
        },
        {
          title: "Livraison à domicile avec signature 9,99€",
          props: {
            subtitle: "Colissimo",
            class: "px-0",
          },
        },
      ],

      errorProductLoading: false,

      loadingDialog: {
        text: "Chargement du produit...",
        color: "accent",
        spinnerValue: "0",
      },
    };
  },
  computed: {
    loadingProduct: function() {
      return !this.productData.name || !this.productData?.pictures[0];
    },
  },
  watch: {
    productData: function() {
      this.activeProductPicture = this.productData.pictures[0];
    },
  },
  methods: {
    addToCart() {
      const cartStore = useCartStore();

      cartStore.setItem(this.productData.id);
    },
  },
  created() {
    const config = useRuntimeConfig();
    const storeStore = useStoreStore();

    const productid = "X9ZUtmksaPsMOAICtzY7";

    if (storeStore.products[0]) this.productData = storeStore.products[0];

    axios.get(`${config.public.apiBase}/getProduct?productId=${productid}`, {
      headers: {
        Authorization: `Bearer ${config.public.apiToken}`,
      },
    }).then((response) => {
      this.productData = response.data.product;

      storeStore.updateProducts([this.productData]);
    }).catch(() => {
      this.errorProductLoading = true;

      this.loadingDialog = {
        text: "Une erreur serveur s'est produite.",
        color: "error",
        spinnerValue: "100",
      };
    });
  },
};
</script>

<style>
.offset-img {
  margin-top: 10px;
  z-index: 10!important;
}
</style>
